export const ApiRoutes = {
  AppConfig: {
    GetAppConfig: '/api/config',
    GetCountries: '/api/config/countries',
    GetLocalizedStrings: '/api/config/localized-strings',
  },
  Auth: {
    GetAntiForgeryToken: 'api/auth/antiforgery',
    GetAuthAppRedirectToken: '/api/auth/app-redirect-token',
    GetAuthStatus: '/api/auth/status',
    SendVerificationCode: '/api/auth/activation-code:send',
    ValidateVerificationCode: '/api/auth/activation-code:validate',
    GetPolicy: '/api/auth/policy:info',
    GetUserPolicies: '/api/auth/user-policy:infos',
    SignUserPolicies: '/api/auth/user-policy:signoffs',
    RefreshUserToken: '/api/auth/refresh',
    RecoverPin: '/api/auth/activation-code:recover',
    GrantLoginPermissions: '/api/auth/grant-login-permissions'
  },
  User: {
    GetInvite: '/api/user/invite',
    FindInvites: '/api/user/find-invites',
    PendingInvites: '/api/user/pending-invites',
    RegisterInvite: '/api/user/register',
    Profile: '/api/user/profile',
    Password: '/api/user/password'
  },
  // MM-42239: must stay in sync with ZBEdgeUrlPaths.OIDCReturnDiagnostics / OIDCReturnDiagnosticsSubmit.
  Diagnostics: {
    OIDCReturn: '/api/diagnostics/oidc-return',
    OIDCReturnSubmit: '/api/diagnostics/oidc-return:submit'
  },
  // MM-42243: must match AdminInvitesController routes. CsvHeaders reads a client CSV's column names (schema-agnostic)
  // to populate the column-mapping modal. ParseInvites previews a CSV into editable grid rows;
  // LoadInvites commits the (re-serialized) grid as the bulk invite batch. InviteApplications feeds the Source App
  // multi-select; InviteAccountTypes feeds the Application Account Type dropdown (the tenant type AccountTypeName is
  // validated against) and InviteUserAccountTypes the per-row User Account Type (ClinicalUser/ZBEmployee). Countries
  // reuse AppConfig.GetCountries.
  Admin: {
    CsvHeaders: '/api/admin/invites:headers',
    ParseInvites: '/api/admin/invites:parse',
    LoadInvites: '/api/admin/invites:load',
    ExportInvites: '/api/admin/invites:export',
    InviteApplications: '/api/admin/invites/applications',
    InviteAccountTypes: '/api/admin/invites/account-types',
    InviteUserAccountTypes: '/api/admin/invites/user-account-types'
  }
}